<template>
    <div class="app flex-row align-items-center animated fadeIn">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6">
                    <div class="card p-0 m-0">
                        <div class="card-body">
                            <div class="h2">{{ $t('login') }}</div>
                            <p class="text-muted">{{ $t('Sign in to your account') }}</p>
                            <div class="control" v-if="invalid_login">
                                <div class="bg-danger text-center card">
                                    <div class="card-body">
                                        <blockquote class="card-blockquote">
                                            <p>{{ $t('Invalid User Credentials Please Try Again') }}</p>
                                        </blockquote>
                                    </div>
                                </div>
                            </div>
                            <p class="control">
                                <input
                                    @keyup.enter="login"
                                    name="email"
                                    v-model="credentials.email"
                                    v-validate="'required|email'"
                                    :class="{'form-control': true, 'is-invalid': errors.has('email')}"
                                    type="text"
                                    :placeholder="$t('email')"
                                />
                                <span
                                    v-show="errors.has('email')"
                                    class="help is-danger"
                                >{{ $t(errors.first('email')) }}</span>
                            </p>
                            <p class="control">
                                <input
                                    @keyup.enter="login"
                                    name="password"
                                    v-model="credentials.password"
                                    v-validate="'required'"
                                    :class="{'form-control': true, 'is-invalid': errors.has('password')}"
                                    type="password"
                                    :placeholder="$t('Password')"
                                />
                                <span
                                    v-show="errors.has('password')"
                                    class="help is-danger"
                                >{{ errors.first('password') }}</span>
                            </p>

                            <div class="row mb-2">
                                <div class="col-6">
                                    <button
                                        @click="login()"
                                        type="button"
                                        class="btn btn-primary px-4"
                                    >{{ $t('Login') }}</button>
                                </div>
                                <div class="col-6 text-right">
                                    <button
                                        type="button"
                                        class="btn btn-link px-0"
                                        v-hide
                                    >{{ $t('Forgot Password') }}</button>
                                </div>
                            </div>

                            <div class="h2 text-center">
                                <hr />
                            </div>
                            <p class="text-muted mt-2">{{ $t('Sign Up Your Account Today') }}</p>
                            <a
                                class="btn btn-primary active mt-2 btn-block"
                                href="#"
                                @click.prevent="redirect_with_loader('/user/register')"
                            >{{ $t('Register') }}</a>
                            <b-button
                                v-hide
                                class="btn-block mt-2"
                                variant="facebook text"
                                @click="redirect_to('/authorize/fb')"
                            >
                                <span>{{ $t('Facebook') }}</span>
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

/**
 * @vuese
 *
 * @group Authentication
 *
 * Login Page
 */
export default {
	name: 'login',

	data() {
		return {
			/**
			 * @vuese
			 *
			 * Login Credentials
			 *
			 * @type Object
			 */
			credentials: {
				email: '',
				password: '',
			},
			/**
			 * @vuese
			 *
			 * Login is valid or not
			 *
			 * @type Boolean
			 */
			invalid_login: false,
		}
	},
	methods: {
		/**
		 * @vuese
		 *
		 * Login
		 *
		 * @return {void}
		 */
		login() {
			this.invalid_login = false
			this.$validator.validateAll().then((result) => {
				if (result) {
					// valid form
					this.$root.loader = true
					axios
						.post('/passport/login', this.credentials)
						.then((response) => {
							this.$root.loader = false
							const token = response.data.access_token
							localStorage.setItem('token', token)
							axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
							this.$store.commit('set_acl', {is_login: true})
							this.$router.push(this.$route.query.redirect || '/')
						})
						.catch(() => {
							this.$root.loader = false
							this.invalid_login = true
						})
				}
			})
		},
	},
	created() {
		this.$root.loader = !true
	},
}
</script>
